import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getCartTotal } from "../../redux/actions/cartAction";
import { getWishlistTotal } from "../../redux/actions/wishListActon";

const BOTTOM_NAV_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@600;700;800;900&display=swap');

  .bnav-wrap {
    display: none;
    position: fixed;
    bottom: 0; left: 0; right: 0;
    z-index: 9000;
    background: rgba(255,255,255,0.96);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-top: 1px solid rgba(226,232,240,0.8);
    box-shadow: 0 -8px 32px rgba(0,0,0,0.08);
    padding: 6px 8px calc(6px + env(safe-area-inset-bottom));
  }
  @media (max-width: 991px) { .bnav-wrap { display: block; } }

  .bnav-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    list-style: none;
    margin: 0; padding: 0 16px;
    max-width: 500px;
    margin: 0 auto;
    gap: 0;
  }

  .bnav-item { flex: 1; }

  .bnav-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    padding: 8px 4px;
    border-radius: 16px;
    text-decoration: none;
    color: #94a3b8;
    font-family: 'Inter', sans-serif;
    transition: all 0.22s cubic-bezier(0.4,0,0.2,1);
    position: relative;
    background: transparent;
    border: none;
    cursor: pointer;
    width: 100%;
  }
  .bnav-btn:hover { color: #14b8a6; background: rgba(20,184,166,0.06); }
  .bnav-btn.bnav-active {
    color: #0d9488;
    background: rgba(20,184,166,0.12);
    border-radius: 12px;
  }
  .bnav-btn:active { transform: scale(0.91); }

  /* Active indicator bar */
  .bnav-btn.bnav-active::after {
    content: '';
    position: absolute;
    bottom: 2px; left: 50%; transform: translateX(-50%);
    width: 20px; height: 3px;
    background: #14b8a6;
    border-radius: 100px;
  }
  /* Remove old ::before dot */
  .bnav-btn.bnav-active::before { display: none; }

  .bnav-icon {
    width: 24px; height: 24px;
    display: flex; align-items: center; justify-content: center;
    transition: transform 0.22s ease;
  }
  .bnav-btn.bnav-active .bnav-icon,
  .bnav-btn:hover .bnav-icon { transform: translateY(-2px); }

  .bnav-label {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.01em;
    text-transform: capitalize;
    line-height: 1;
    transition: color 0.2s;
  }

  .bnav-badge {
    position: absolute;
    top: 4px; right: calc(50% - 20px);
    background: linear-gradient(135deg, #14b8a6, #0d9488);
    color: #fff;
    font-size: 9px; font-weight: 900;
    min-width: 17px; height: 17px;
    border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(20,184,166,0.4);
    animation: bnavPop 0.3s ease;
    z-index: 2;
  }
  @keyframes bnavPop {
    from { transform: scale(0); }
    to   { transform: scale(1); }
  }
`;

const NAV_ITEMS = [
  {
    to: "/",
    label: "Home",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    to: "/shop",
    label: "Shop",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    ),
  },
  {
    to: "/category",
    label: "Category",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect width="7" height="7" x="3" y="3" rx="1" />
        <rect width="7" height="7" x="14" y="3" rx="1" />
        <rect width="7" height="7" x="14" y="14" rx="1" />
        <rect width="7" height="7" x="3" y="14" rx="1" />
      </svg>
    ),
  },
  {
    to: "/wishlist",
    label: "Saved",
    badge: "wish",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      </svg>
    ),
  },
  {
    to: "/myaccount",
    label: "Account",
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

function Hmain3() {
  const dispatch = useDispatch();
  const totalItems = useSelector((state) => state.wishlist.totalItems);
  const location = useLocation();

  useEffect(() => {
    dispatch(getCartTotal());
    dispatch(getWishlistTotal());
  }, [dispatch]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <>
      <style>{BOTTOM_NAV_STYLES}</style>
      <nav className="bnav-wrap" aria-label="Mobile bottom navigation">
        <ul className="bnav-list">
          {NAV_ITEMS.map(({ to, label, icon, badge }) => (
            <li key={to} className="bnav-item">
              <Link
                className={`bnav-btn${isActive(to) ? " bnav-active" : ""}`}
                to={to}
                aria-label={label}
                aria-current={isActive(to) ? "page" : undefined}
              >
                <span className="bnav-icon">{icon}</span>
                <span className="bnav-label">{label}</span>
                {badge === "wish" && totalItems > 0 && (
                  <span className="bnav-badge">{totalItems}</span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}

export default Hmain3;
